export default Object.freeze({
  default           : 0,
  blackPencil       : 1,
  redPencil         : 2,
  bluePencil        : 3,
  orangePencil      : 4,
  greenPencil       : 5,
  blackPen          : 6,
  redPen            : 7,
  bluePen           : 8,
  orangePen         : 9,
  greenPen          : 10,
  blackHighlighter  : 11,
  redHighlighter    : 12,
  blueHighlighter   : 13,
  orangeHighlighter : 14,
  greenHighlighter  : 15,
  eraser            : 16,
  pointer           : 17,
  dragging          : 18,
  rotating          : 19,
  resizingSW        : 20,
  resizingSE        : 21,
  menu              : 22,
});
